import { clamp } from "../simulation/vector";

/** Peak earthshine as a directional-light intensity. Visible but secondary to sunlight. */
export const EARTHSHINE_PEAK_INTENSITY = 0.42;

/**
 * Sunlight bounced from Earth's dayside onto the Moon's night side.
 * Strongest at New Moon (Earth is nearly full as seen from the Moon) and gone at Full Moon.
 */
export function earthshineIntensity(illuminatedFraction: number): number {
  if (!Number.isFinite(illuminatedFraction)) {
    throw new RangeError("Illuminated fraction must be a finite number");
  }

  const earthDayside = clamp(1 - illuminatedFraction, 0, 1);
  return earthDayside * EARTHSHINE_PEAK_INTENSITY;
}
